import Vue from 'vue'
import axios from 'axios'
import {UPLOAD_ADDR} from '@/config.js'

// 默认 X-Token-Key（鉴权密钥，可通过 window._uploadConfig.tokenKey 覆盖）
const DEFAULT_TOKEN_KEY = 'xh_local_test.local-test-secret-20260813-channel-center';
// 默认 filePath 文件分类（goods商品图 ad海报/广告图 quote报价图 cr轮播图片，可通过 window._uploadConfig.filePath 覆盖）
const DEFAULT_FILE_PATH = 'goods';

var app = new Vue();

/**
 * 上传单个文件
 * @param {Object} item 文件项，包含 file(File对象)、progress/success/fail 回调
 * @param {String} filePath 文件路径分类
 * @param {String} tokenKey 鉴权 token
 * @returns {Promise<Object|null>} 成功返回 {path, fileObj}，失败返回 null
 */
function uploadOne(item, filePath, tokenKey) {
	var file = item.file;
	// 使用 FormData 构建 multipart/form-data 请求体
	var formData = new FormData();
	formData.append('file', file);

	return axios.post(UPLOAD_ADDR, formData, {
		// filePath 作为 query 参数传递
		params: { filePath: filePath },
		// X-Token-Key 作为请求头传递
		headers: { 'X-Token-Key': tokenKey }
	}).then(function(res) {
		var data = res.data;
		// 接口返回 code == 0 表示上传成功
		if (data && data.code == 0 && data.data && data.data.fileUrl) {
			var fileUrl = data.data.fileUrl;
			// 将返回的文件地址挂在 file 对象上，便于后续使用
			file.file_path = fileUrl;
			// 调用单文件成功回调，返回文件访问地址
			item.success && item.success(fileUrl);
			return { path: fileUrl, fileObj: file };
		} else {
			console.error('上传失败:', data && data.message);
			item.fail && item.fail();
			return null;
		}
	}).catch(function(err) {
		console.error('上传异常:', err);
		item.fail && item.fail();
		return null;
	});
}

/**
 * 文件上传
 * @param {Array} files 文件数组，每项包含 file(File)、progress、success、fail 回调
 * @param {Object} opt 配置项，包含 success(全部完成回调)、complete(结束回调)
**/
async function upload(files, opt) {
	if (files.length == 0) return;

	// 读取上传配置（可通过 window._uploadConfig 覆盖默认值）
	var config = window._uploadConfig || {};
	var filePath = config.filePath || DEFAULT_FILE_PATH;
	var tokenKey = config.tokenKey || DEFAULT_TOKEN_KEY;

	var errorCount = 0;
	var successCount = 0;
	// 按原始顺序存放上传结果，保持与输入顺序一致
	var fruit = new Array(files.length);

	// 并发上传所有文件
	var promises = files.map(function(item, i) {
		let type = item.file.name.match(/\.[^\.]+$/)[0];
		return uploadOne(item, ['.png', '.jpg', '.jpeg'].includes(type.toLowerCase()) ? filePath : 'zip', tokenKey).then(function(result) {
			if (result) {
				successCount++;
				fruit[i] = result;
			} else {
				errorCount++;
			}
		});
	});

	await Promise.all(promises);

	// 全部上传完成后，调用 opt.success 返回结果数组 [{path, fileObj}]
	if (successCount) {
		opt.success && opt.success(fruit.filter(function(item) { return !!item; }));
	}

	// 调用结束回调
	opt.complete && opt.complete();

	// 上传结果提示（可通过 window._uploadConfig.message 关闭）
	if (!config || !config.message) {
		var message = !errorCount ? '上传成功'
			: !successCount ? '上传失败，请重试'
			: '上传完成，失败' + errorCount + '个';
		app.$message({ message: message });
	}

	// 清理临时配置
	delete window._uploadConfig;
}

export default upload
